import { useContext, useState, createContext, useEffect, useCallback, useRef } from 'react'
import type { PropsWithChildren } from 'react'
import { ICourse, ISemester } from '../types/ICourse'
import { getCourses } from '../data/courses'
import { IApiContext } from '../types/Shared'
import { useAuthenticationContext } from './authenticationprovider'
export const CoursesContext = createContext<ICoursesContext>({ Pending: true, getCourseById: () => undefined, setSemester: () => undefined })
export function useCoursesContext() {
  return useContext(CoursesContext)
}

export interface ICoursesContext extends IApiContext<ICourse[]> {
  getCourseById: (courseId?: string) => ICourse | undefined;
  setSemester: (semester: ISemester) => void;
}

export function CoursesProvider({ children }: PropsWithChildren<{}>) {

  let _currentSemester = useRef<ISemester>();
  const authContext = useAuthenticationContext();
  const [courses, setCourses] = useState<ICourse[]>();
  const [error, setError] = useState();
  const [pending, setPending] = useState(true);
  const [semester, setSemester] = useState<ISemester>();

  const getCourseById = useCallback((courseId?: string): ICourse | undefined => {
    if(courseId)
    {
      return courses?.find(c => c.SIS === courseId);
    }
  }, [courses])

  useEffect(() => {
    setError(undefined);
    setPending(true);
    if (semester && authContext.Result) {   
      _currentSemester.current = semester;   
      getCourses(semester, authContext.Result).then(courseResponse => {
        if(courseResponse.Semester === _currentSemester.current)
        {
          setCourses(courseResponse.Courses);
        }
      }).catch(err => {
        setError(err.message || err);
      }).finally(() => {
        setPending(false);
      })
    }
  }, [semester, authContext])
  return (
    <CoursesContext.Provider value={{ Error: error, Pending: pending, Result: courses, getCourseById, setSemester }}>
      {children}
    </CoursesContext.Provider>
  )
}